import { defineStore } from "pinia";

export const useOccupationStore = defineStore('occupation', {
    state: () => ({
        occupation: {},
        occupations: [],
        occupationsSelect: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setOccupation(occupation) {
            this.occupation = occupation
        },
        setOccupationsSelect(occupationsSelect) {
            this.occupationsSelect = occupationsSelect
        },
        setOccupations(occupations) {
            this.occupations = occupations
        },
        addOccupation(occupation) {
            this.occupations.unshift(occupation)
        },
        updateOccupation(occupation) {
            let index = this.occupations.findIndex(cl => cl.id === occupation.id)
            this.occupations.splice(index, 1, occupation)
        },
        deleteOccupation(occupation) {
            let index = this.occupations.findIndex(cl => cl.id === occupation.id)
            this.occupations.splice(index, 1)
        },
    },
});